import React from "react";

function ItemList({ name, description, price, img, menuPrice, menuIncludes, extra }) {
  const defaultImg =
    "https://www.unileverfoodsolutions.es/dam/global-ufs/inspiration-&-training/future-menus/2023-modernized-comfort-food/site-and-social-media-/site_banner_1260x700/dish-shots/Site_Banner_1260x700_Yasamine%20Attaman%20recipe.jpg";

  const hasMenu = Boolean(menuPrice);
  const hasSolo = price !== undefined && price !== null && String(price).trim() !== "";
  const menuOnly = hasMenu && !hasSolo;

  return (
    <div className="bg-white rounded-2xl shadow-sm overflow-hidden border border-gray-100 hover:shadow-md transition-shadow">
      <div className="relative">
        <img
          src={img || defaultImg}
          alt={name}
          className="w-full h-48 object-cover"
          loading="lazy"
        />
      </div>

      <div className="p-5">
        <h3 className="text-lg font-bold text-gray-900">{name}</h3>

        {description && (
          <p className="text-gray-600 text-sm mt-2 leading-relaxed">
            {description}
          </p>
        )}
        {extra && (
          <div className="mt-3">
            <span className="inline-flex items-center bg-yellow-100 text-yellow-800 border border-yellow-300 text-xs font-semibold px-3 py-1 rounded-full">
              Extra disponible: {extra}
            </span>
          </div>
        )}

        {hasMenu && menuIncludes && (
          <div className="mt-3">
            <span className="inline-flex items-center gap-2 bg-gray-50 border border-gray-200 text-gray-700 text-xs font-medium px-3 py-1 rounded-full">
              <span className="text-gray-900 font-semibold">Incluye:</span>
              {menuIncludes}
            </span>
          </div>
        )}

        {/* PRECIOS */}
        <div
          className={[
            "mt-5 w-full flex items-end",
            menuOnly ? "justify-end" : "justify-between",
          ].join(" ")}
        >
          {/* SOLO */}
          {hasSolo && (
            <div>
              <div className="text-xs text-gray-500">Solo</div>
              <div className="text-xl font-extrabold text-gray-900">{price}</div>
            </div>
          )}

          {/* MENÚ */}
          {hasMenu && (
            <div className="text-right">
              <div className="text-xs text-gray-500">Menú</div>
              <div className="text-xl font-extrabold text-blue-600">
                {menuPrice}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ItemList;